import { Injectable } from '@angular/core';
import { getTimezone } from '../../dataprotection-common/utils';
import { HttpUtils } from '../../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  getAllVapps(vdcId) {
    return this.http
      .get( HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapps?timezone=' + encodeURIComponent(getTimezone()) )
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/vapps/vapps.service.ts